import { MessageType } from '@tencent/dz-models';
export enum LeaveMsgTypeEnum {
  OfflineForm = 1, // 离线留言表单
  QuickForm = 2, // 快速预约表单
  QuestionForm = 3, // 问题快捷表单
  SearchForm = 4, // 搜索页卡表单
  QuickSearchForm = 5, // 搜索自助咨询表单
  QuickPhone = 6, // 客服推荐一键手机号表单
}

export const LeaveMsgTypeWithMsgTypeMap: any = {
  [MessageType.OfflineForm]: LeaveMsgTypeEnum.OfflineForm,
  [MessageType.FormOrder]: LeaveMsgTypeEnum.QuickForm,
  [MessageType.MedicaleForm]: LeaveMsgTypeEnum.SearchForm,
  [MessageType.SelfConsultForm]: LeaveMsgTypeEnum.QuickSearchForm,
  [MessageType.QuickPhoneForm]: LeaveMsgTypeEnum.QuickPhone,
};
